import React from "react";
import RadioButton from "../inputs/RadioButton";
import { Fields } from "../../content/fields";
import { Title } from "../../content/title";
import { Lang } from "src/types/common-types";
import gs from "../../Layout.module.scss";
import style from "./FamilyStatus.module.scss";
import { Dispatch } from "src/types/store-types";
import Applicant from "src/types/applicant";
import { actions } from "../../store/store";

interface Props {
  lang: Lang;
  state: Applicant;
  invalidFields: (string | false)[];
  dispatch: Dispatch;
  disabled: boolean;
}

function FamilyStatus({ lang, state, invalidFields, dispatch, disabled }: Props) {
  return (
    <div className={style.familyStatusButtonBox}>
      <span className={gs.header}>{Title.familyStatusTitle[lang]}</span>
      <RadioButton
        disabled={disabled}
        label={state.sex === 2 ? Fields.unmarriedM?.label[lang] : Fields.unmarriedF?.label[lang]}
        onClick={() => {
          dispatch({
            type: actions.FAMILY_STATUS,
            data: 1,
          });
        }}
        active={state.familyStatus === 1}
      />
      <RadioButton
        disabled={disabled}
        label={state.sex === 2 ? Fields.marriedM?.label[lang] : Fields.marriedF?.label[lang]}
        onClick={() => {
          dispatch({
            type: actions.FAMILY_STATUS,
            data: 2,
          });
        }}
        active={state.familyStatus === 2}
      />
    </div>
  );
}

export default FamilyStatus;
